import Badge from '@components/Badge';
import MicSelection from '@components/MicSelection';
import MicrophoneActivityPreview from '@components/MicrophoneActivityPreview';
import { useAudioInputs } from '@providers/DevicesProvider';
import type { FC } from 'react';
import {
  Container,
  DeviceControlArea,
  DeviceControlLeft,
  DeviceControlRight,
  DeviceName,
  DeviceStatusArea,
} from './style';

const Microphone: FC = () => {
  const { selectedDevice } = useAudioInputs();
  const isSelectedDevice = selectedDevice !== undefined;

  return (
    <Container>
      <DeviceStatusArea>
        <DeviceName>마이크</DeviceName>
        <Badge type={isSelectedDevice ? 'success' : 'fail'}>
          {isSelectedDevice ? '완료' : '대기중'}
        </Badge>
      </DeviceStatusArea>
      <DeviceControlArea>
        <DeviceControlLeft>
          <MicSelection />
        </DeviceControlLeft>
        <DeviceControlRight>
          <MicrophoneActivityPreview />
        </DeviceControlRight>
      </DeviceControlArea>
    </Container>
  );
};

export default Microphone;
